import { COLLABORATIONS_DATA } from "data/collaborations";

export const collaborationsPrepareData = (data: any) => {
  const info = data.prismicCollaborations?.data;
  return {
    header: info?.header?.text ?? COLLABORATIONS_DATA.header,
    items: info?.items?.map((item: any) => ({
      label: item?.label?.text,
      image: item?.image,
    })),
    banner: {
      header: info?.tab_text?.text ?? COLLABORATIONS_DATA.banner.header,
      headerMobile:
        info?.tab_text?.text ?? COLLABORATIONS_DATA.banner.headerMobile,
      button: info?.tab_button_label?.text,
    },
  };
};
